<template>
<div>
  <section class="content-header">
    <h1>{{$t('label.list')}}</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <router-link :to="{ name: 'LabelCreate' }" class="btn btn-primary pull-right">{{$t('label.add')}}</router-link>
      </div>
      <div class="box-body">
        <item-list-errors :entity="'label'"></item-list-errors>

        <api-table
                :entity="'Label'"
                :route="'labels'"
                :path="'label'"
                :filterable="filterable"
                :sortable="sortable"
                :columns="columns"
        ></api-table>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import ItemListErrors from '../layout/errors/ItemListErrors'
import ApiTable from '../ApiTable'

export default {
  components: {ItemListErrors, ApiTable},
  data: function () {
    return {
      columns: ['id', 'name', 'actions'],
      filterable: ['id', 'name'],
      sortable: ['id', 'name'],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/label/List.vue